import { call, put, takeEvery } from "redux-saga/effects"
import history from "utils/history"
import {
  storeServiceDetail,
  storeErrorMessage,
  GET_SERVICE_DETAIL,
} from "actions"
import { callApi } from "sagas/Api"
import serviceDetailAPI from "api/service/detail"

export function* handleGetServiceDetail() {
  yield takeEvery(GET_SERVICE_DETAIL, execGetServiceDetail)
}

export function* execGetServiceDetail(action) {
  const { payload, error } = yield call(
    callApi,
    serviceDetailAPI,
    action.payload
  )
  if (payload && !error && payload.toses.length !== 0) {
    yield put(storeServiceDetail(payload))
  } else {
    yield put(storeErrorMessage(error))
    history.push("/SorryPage")
  }
}
